// extracted by mini-css-extract-plugin
export default {"base":"StateRiskMap_base__dwWWB","map_container":"StateRiskMap_map_container__fQFMB"};